import React, { useContext } from 'react';

// Custom
import AppPage from '@/ui/AppPage/AppPage';
import MapCentricPage from '@/ui/MapCentric/MapCentricPage';
import Permissions from '@/lib/permissions';
import UserContext from '@/context/UserContext/UserContext';

import modelKoncesija from '@/models/koncesija';

import KoncesijeDialog from './KoncesijaDialog';
import DialogContext from '@/context/DialogContext/DialogContext';
import KoncesijaHistoryDialog from './KoncesijaHistoryDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';

const KoncesijeMapCentricPage = () => {
  const userContext = useContext(UserContext);
  const { showDialog } = useContext(DialogContext);

  const handleCustomAction = (action: string, id: number, record?: { [key: string]: any }) => {
    if (action === 'show_history') {
      // console.log(record, id)
      showDialog(KoncesijaHistoryDialog, {
        level: 1,
        onClose: () => {},
        gid: record?.gid
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    // console.log(action, record.has_history)
    if (action === 'show_history' && record.has_history) {
      return true
    }
    return false;
  }

  return (
    <AppPage titlett="koncesije:page.koncesije" needPermission={[Permissions.KoncesijeView]}>
      <MapCentricPage
        model={modelKoncesija}
        titleToken="koncesije:titles.koncesije"
        view="default"
        baseRecordPath={modelKoncesija.apiPath}
        mapId={65}
        mapModel={modelKoncesija}
        allowAdd={userContext?.hasAnyPermission([Permissions.KoncesijeEdit])}
        allowEdit={userContext?.hasAnyPermission([Permissions.KoncesijeEdit])}
        dialogComponent={KoncesijeDialog}
        dialogForm="default"
        allowView
        // onCustomTableAction={handleCustomAction}
        allowExport
        allowExportShape
        onCustomTableAction={handleCustomAction}
        allowShowDeleted
        allowCustomTableAction={allowRowAction}
      />
    </AppPage>
  );
};

export default KoncesijeMapCentricPage;
